class SinalizacaoModel {

    id: number | null;
    id_entidade: number | null;
    anotacoes: string | null;
    data_hora: string | null;
    id_usuario: number | null;
    name: string | null;
    email: string | null;
    agendamento: boolean;
    agendamento_data_hora: string | null;

    constructor() {
        this.id = null;
        this.id_entidade = null;
        this.anotacoes = null;
        this.data_hora = null;
        this.id_usuario = null;
        this.name = null;
        this.email = null;
        this.agendamento = false;
        this.agendamento_data_hora = null;
    }

}

export default SinalizacaoModel;
